<template>
    <div class="mt-6 has-text-white content">
        <h3 class="has-text-white">Registration</h3>
        <div class="mt-6 pb-6">
            <div class="columns is-gapless">
                <div class="column is-narrow"><i class="far fa-fw fa-info-circle mr-2"></i></div>
                <div class="column">
                    <span class="has-text-weight-bold">You have pre-registered for this conference.</span><br>Additional information for this event may be made available to you as the event approaches.
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {

    };
</script>

<style scoped>

</style>
